module.exports = __webpack_public_path__ + "static/media/ico-training.0f58e0c0.svg";